export const editions = [
  {
    id: 'micro',
    name: 'Micro Edition',
    ageRange: '4-9',
    description: 'Perfect for young learners! Filled with colorful stories, simple puzzles, and fun activities that make early learning a joyful adventure.',
    color: 'bg-accent-blue',
    thumbnail: '/samples/micro-sample-1.pdf', // Add your actual PDF path
    features: [
      'Picture-rich stories with simple words',
      'Easy puzzles and mazes',
      'Coloring and drawing activities',
      'Number and letter practice',
      'Fun facts about animals and nature',
      'Simple science experiments',
    ],
    additionalBenefits: [
      'Parent guide included',
      'Vocabulary building exercises',
      'Interactive stickers',
      'Monthly achievement certificates',
    ],
    samplePages: [
      { icon: '📖', title: 'Stories' },
      { icon: '🎨', title: 'Coloring' },
      { icon: '🧩', title: 'Puzzles' },
    ],
  },
  {
    id: 'macro',
    name: 'Macro Edition',
    ageRange: '10-15',
    description: 'Engaging content for curious minds! News, challenging puzzles, creative writing prompts, and thought-provoking articles that inspire learning.',
    color: 'bg-primary-green-light',
    thumbnail: '/samples/macro-sample-1.pdf', // Add your actual PDF path
    features: [
      'Current news and world events',
      'Brain-teasing logic puzzles',
      'Creative writing corner',
      'Science and technology features',
      'Book and movie reviews',
      'Reader contributions section',
    ],
    additionalBenefits: [
      'Monthly contests with prizes',
      'Student achievement spotlights',
      'College prep tips',
      'Career exploration articles',
    ],
    samplePages: [
      { icon: '📰', title: 'News' },
      { icon: '🧠', title: 'Brain Teasers' },
      { icon: '✍️', title: 'Creative Corner' },
    ],
  },
];